var PS_METRIC_ICON = (label, platform = "") => {
    // 21.10.2026: іконка метрики за підписом будь-якою мовою магазину - дзеркало snippets/metric-icon-key.liquid (той самий порядок). var, бо ці 3 файли можуть бути на одній сторінці
    const l = String(label).toLowerCase(), pl = String(platform).toLowerCase()
    if (/platform|plattform|plataforma|piattaform|платформ/.test(l)) return "platforms"
    if (/play|stream|стрим|стрім|прослух|прослуш|reproduc|riproduz|reproduç|wiedergab/.test(l)) return "plays"
    if (/view|aufruf|vista|visualiz|просмотр|перегляд/.test(l)) return "views"
    if (/subscriber|abonnent|suscriptor|iscritt|subscritor/.test(l)) return "subscribers"
    if (/подписчик|підписник/.test(l)) return pl.includes("youtube") ? "subscribers" : "followers"
    if (/follow|fan|seguidor/.test(l)) return "followers"
    if (/save|guardad|salvatagg|salvament|gespeichert|сохранен|збережен/.test(l)) return "saves"
    if (/like|лайк|вподоба|gusta|mi piace|gosto/.test(l)) return "likes"
    if (/listener|hörer|oyente|ascoltator|ouvinte|слушател|слухач/.test(l)) return "listeners"
    if (/repost|репост/.test(l)) return "reposts"
    if (/comment|kommentar|comentar|комментар|коментар/.test(l)) return "comments"
    if (/blog|блог/.test(l)) return "music-blogs"
    if (/radio|station|радио|радіо/.test(l)) return "radio-airplay"
    return ""
}
// 21.10.2026: «50 000» (ru/uk) - групи тисяч через пробіл лишаються в числі (нерозривний пробіл), не йдуть у підпис
var PS_NUM_RE = /^(~?[\d][\d.,:]*(?:[\s\u00a0\u202f]\d{3}(?!\d))*\s*%?(?:\s*[\u2013\u2014-]\s*[\d][\d.,]*)?\s*[kKmM]?)[\s-]*(.*)$/
var PS_NUM_FMT = (s) => String(s).replace(/(\d)[\s\u00a0\u202f]+(?=\d{3}(?!\d))/g, "$1#").replace(/\s+/g, "").replace(/#/g, "\u00a0")

class ProductCard {

    constructor(card) {
        this.card = card

        this.type = card.dataset.cardType || "default"
        this.collection = card.dataset.collection || ""

        this.variantsBox = card.querySelector(".svc-card__variants")
        this.subproductsBox = card.querySelector(".svc-card__subproducts")
        this.subproducts = card.querySelectorAll(".svc-card__subproduct")
        this.currentSubName = card.querySelector(".svc-card__subproduct-name")
        // ТІЛЬКИ ціна в тоглі, а не перший елемент списку — інакше JS затирав
        // Liquid-ову "From $X" на активному (першому) пункті списку.
        this.currentSubPrice = card.querySelector(".svc-card__subproduct-select .svc-card__subproduct-price")
        this.priceBox = card.querySelector(".svc-card__price--2")
        this.form = card.querySelector(".svc-card__form")

        this.productTitle = card.querySelector(".svc-card__title").textContent
        if (this.type === "instant") {
            this.headerTitle = card.querySelector(".svc-card__screen--3 .svc-card__header-title")
        } else {
            this.headerTitle = card.querySelector(".svc-card__screen--2 .svc-card__header-title")
        }

        this.currentVariants = []
        this.currentVariant = null

        this.init()
    }

    init() {

        this.setScreen(1)

        if (this.headerTitle) {
            this.headerTitle.textContent = this.productTitle
        }
        this.initSubproductPrices()
        this.initFirstSubproduct()

        if (this.type === "variants") {
            this.card.querySelector(".svc-card__subproduct-select")?.remove()
        }

        if (this.type === "variants" || this.type === "instant") {
            this.initVariantsFromHTML()
        }


        // 08.09.2026: pack (Artist Pack) = один варіант, купівля зі звороту-складу
        if (this.type === "simple" || this.type === "pack") {
            this.currentVariant = {
                id: this.form.querySelector("[name=id]").value,
                title: this.form.querySelector("[name=variant_title]").value,
                price: this.form.querySelector("[name=price]").value
            }
        }

    }

    initVariantsFromHTML() {

        if (!this.card.dataset.variants) return

        this.currentVariants = JSON.parse(this.card.dataset.variants)

        this.renderVariants()

    }

    setScreen(screen) {

        this.card.classList.remove(
            "is-screen-1",
            "is-screen-2",
            "is-screen-3"
        )

        this.card.classList.add(`is-screen-${screen}`)

        // SimpleBar на списку сервісів ініціалізувався прихованим (розміри = 0).
        // Коли екран стає видимим — перерахувати, інакше тач-скрол мертвий і
        // скролбар невидимий (mobile-first). WeakMap-інстанс, не element.SimpleBar.
        window.requestAnimationFrame(() => {
            const box = this.subproductsBox
            if (!box || box.offsetParent === null) return
            try {
                const sb = window.SimpleBar && SimpleBar.instances && SimpleBar.instances.get(box)
                if (sb && typeof sb.recalculate === "function") sb.recalculate()
            } catch (e) {}
        })

    }

    updateTotalPrice() {

        if (!this.currentVariant) return
        if (!this.priceBox) return

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const quantity = parseInt(qtyInput?.value) || 1

        const price = parseFloat(this.currentVariant.price) / 100
        const total = price * quantity

        this.priceBox.textContent = `$${total.toFixed(2)}`
    }

    initFirstSubproduct() {

        if (!this.subproducts.length) return

        const first = this.subproducts[0]

        const title = first.dataset.title
        const variants = JSON.parse(first.dataset.variants)

        first.classList.add("is-active")

        const price = variants[0]?.price || 0

        if (this.currentSubName) {
            this.currentSubName.textContent = title
        }

        if (this.currentSubPrice) {
            this.currentSubPrice.textContent = `$${(price / 100).toFixed(2)}`
        }

        this.currentVariants = variants

        this.renderVariants()

    }

    initSubproductPrices() {

        this.subproducts.forEach(btn => {

            let priceEl = btn.querySelector(".svc-card__subproduct-price")

            // Ціну "From $X" вже відрендерив Liquid (локалізовано, min tier) — не перезаписуємо.
            if (priceEl && priceEl.textContent.trim()) return

            const variants = JSON.parse(btn.dataset.variants || "[]")
            const price = variants.length
                ? Math.min(...variants.map(v => Number(v.price) || Infinity))
                : 0

            if (!priceEl) {
                priceEl = document.createElement("span")
                priceEl.className = "svc-card__subproduct-price"
                btn.appendChild(priceEl)
            }

            priceEl.textContent = `$${(price / 100).toFixed(2).replace(/\.00$/, "")}`

        })

    }

    selectSubproduct(btn) {

        const title = btn.dataset.title
        const variants = JSON.parse(btn.dataset.variants)

        this.subproducts.forEach(item => {
            item.classList.remove("is-active")
        })

        btn.classList.add("is-active")

        const price = variants[0]?.price || 0

        if (this.currentSubName) {
            this.currentSubName.textContent = title
        }

        if (this.currentSubPrice) {
            this.currentSubPrice.textContent = `$${(price / 100).toFixed(2)}`
        }

        this.currentVariants = variants

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const hidden = this.card.querySelector(".svc-card__form [name=quantity]")

        if (qtyInput) qtyInput.value = 1
        if (hidden) hidden.value = 1

        this.renderVariants()

        this.setScreen(2)

    }

    renderVariants() {

        const isInstant = this.type === "instant"
        const box = isInstant ? this.subproductsBox : this.variantsBox
        if (!box) return

        this.currentVariant = null

        // INP: збираємо всі варіанти в DocumentFragment і вставляємо ОДНИМ append —
        // замість reflow на кожен appendChild у циклі (антипатерн "variant selector reflows").
        const frag = document.createDocumentFragment()

        this.currentVariants.forEach((v, index) => {

            let el

            if (isInstant) {
                // 09.09.2026: під розміром показуємо склад (card_spec), якщо він є. Товари без складу
                // рендеряться як раніше - список лишається тим самим.
                el = document.createElement("form")
                el.className = "svc-card__subproduct-form"

                el.innerHTML = `
                <input type="hidden" name="id" value="${v.id}">
                <input type="hidden" name="variant_title" value="${v.title}">
                <input type="hidden" name="product_title" value="${this.productTitle}">
                <input type="hidden" name="price" value="${v.price}">
                <input type="hidden" name="quantity" value="1">
                <input type="hidden" name="collection" value="${this.collection}">
                <button type="button" class="svc-card__subproduct add_to_cart_button">
                    <span class="svc-card__subproduct-body">
                        <span class="svc-card__subproduct-title">${v.title}</span>
                        ${v.raw && v.raw !== v.title ? `<span class="svc-card__subproduct-spec">${String(v.raw).replace(/\s*\+\s*/g, " · ")}</span>` : ""}
                    </span>
                    <span class="svc-card__subproduct-price">$${(v.price / 100).toFixed(2)}</span>
                </button>
            `

            } else {

                el = document.createElement("button")
                el.type = "button"
                el.className = "svc-card__variant"
                el.textContent = v.title

                el.dataset.id = v.id
                el.dataset.title = v.title
                el.dataset.raw = v.raw || ""
                el.dataset.price = v.price

            }

            if (index === 0) {
                el.classList.add("is-active")
            }

            if (!isInstant && index === 0) {
                this.currentVariant = {
                    id: String(v.id),
                    title: v.title,
                    price: String(v.price)
                }
            }

            frag.appendChild(el)

        })

        box.innerHTML = ""
        box.appendChild(frag)

        if (this.currentVariant) {
            this.syncForm()
        }
        if (!isInstant) {
            this.updateVariantDesc(box.querySelector(".svc-card__variant.is-active"))
            // чіпи «1 Day / 3 Days» → підпис Duration замість Quantity
            const lab = this.card.querySelector(".svc-card__variants-label")
            if (lab && lab.dataset.labelDuration) {
                const allDays = this.currentVariants.length > 0 && this.currentVariants.every((v) => /day/i.test(v.title))
                // 09.09.2026: підпис чіпів БЕЗ провідної метрики. Раніше писало «PLAYS», хоча в пакеті ще лайки
                // й коментарі - «1K» читалось як «1K Plays» і вводило в оману (власник). Тепер нейтральне
                // «Package size», а для наборів тривалостей - «Duration».
                lab.textContent = allDays ? lab.dataset.labelDuration : (lab.dataset.labelQuantity || lab.textContent)
            }
        }

    }

    // 07.09.2026: повний склад варіанту під чіпами, якщо чіп - скорочена alt_title (S-Cloud пакети)
    updateVariantDesc(btn) {
        const desc = this.card.querySelector(".svc-card__variant-desc")
        if (!desc || !btn) return
        const list = desc.querySelector("[data-variant-spec]")
        const raw = btn.dataset.raw || ""
        if (!list || !raw || raw === btn.dataset.title) { if (list) list.innerHTML = ""; desc.hidden = true; return }
        // «3.000 Plays + 100 Likes + 50 Comments» / «1-Day Boost» → рядки метрик з іконками (як у бандл-картці)
        const iconFor = (label) => { const k = PS_METRIC_ICON(label, this.card && this.card.dataset.platform); return k === "platforms" ? "" : k }
        const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]))
        const parts = raw.split(/\s*[+\/·]\s*/).map((x) => x.trim()).filter(Boolean)
        // 4+ метрик: з 4-ї починаючи - компактно в один рядок (іконка + число), як у бандл-картці v13
        const items = parts.map((part) => {
            let num = "", label = part
            const days = part.match(/^(\d+)\s*-?\s*(day|days)\b\s*(.*)$/i)
            // 09.09.2026: «~» перед числом = приблизна метрика (естімейт від провідної), напр. «~1,666 Listeners»
            // 09.09: підтримка пропорцій і відсотків - «1:6 Listeners», «~1% Saves», «~0.3% Followers»
            const m = part.match(PS_NUM_RE)
            if (days) { num = days[1] + (days[1] === "1" ? " Day" : " Days"); label = days[3].trim() }
            else if (m) { num = PS_NUM_FMT(m[1]); label = m[2].trim() }
            const ic = iconFor(label)
            const icon = ic ? `<span class="svc-spec-ico menu-item-icon ico-ico-${ic}"></span>` : `<span class="svc-spec-ico svc-spec-ico--check"></span>`
            return { icon, num, label }
        })
        // 09.09.2026: картка фіксовані 424px = 3 рядки складу. Від 4 метрик: 2 звичайні + ОДИН
        // компактний рядок (лише іконка і число, підписи ховає CSS). Раніше Liquid лишав 2, а JS 3 -
        // рендери розбігались; компакт з підписами переносився на 70px і кнопка вилітала з картки.
        const pair = (it) => `<span class="svc-card__spec-pair" title="${esc(it.num + " " + it.label)}">${it.icon}<b class="svc-card__spec-num">${esc(it.num || it.label)}</b>${it.num && it.label ? `<span class="svc-card__spec-lab">${esc(it.label)}</span>` : ""}</span>`
        // 11.09.2026 (власник): «What's included» лише для КОМБІНОВАНОГО пакета (2+ метрики або пропорції).
        // Одна метрика («1.000 Listeners») = те саме, що чіп, підпис висів порожнім - блок не показуємо.
        if (items.length < 2) { list.innerHTML = ""; desc.hidden = true; return }
        // 11.09.2026: рівно 4 метрики - ДВА рядки по парі З підписами («1,000 Plays · 1:6 Listeners» /
        // «~1% Saves · ~0.3% Followers»): влазить у бокс і не ховається за скролом (власник). 5+ - як було.
        const rows = []
        // 14.10.2026 (власник): 3 метрики - головна окремим рядком + дві інші парою з підписами (2 рядки замість 3), не для рядка платформ
        if (items.length === 3 && !items.some(it => /platforms/i.test(it.label))) {
            rows.push(`<li>${items[0].icon}<b class="svc-card__spec-num">${esc(items[0].num)}</b><span class="svc-card__spec-lab">${esc(items[0].label)}</span></li>`)
            rows.push(`<li class="svc-card__spec-row--pair">${pair(items[1])}${pair(items[2])}</li>`)
        } else if (items.length === 4) {
            rows.push(`<li class="svc-card__spec-row--pair">${pair(items[0])}${pair(items[1])}</li>`)
            rows.push(`<li class="svc-card__spec-row--pair">${pair(items[2])}${pair(items[3])}</li>`)
        } else {
            const normalN = items.length > 3 ? 2 : items.length
            const full = items.slice(0, normalN)
            const compact = items.slice(normalN)
            full.forEach((it) => rows.push(`<li>${it.icon}${it.num ? `<b class="svc-card__spec-num">${esc(it.num)}</b>` : ""}<span class="svc-card__spec-lab">${esc(it.label)}</span></li>`))
            if (compact.length) rows.push(`<li class="svc-card__spec-row--compact">${compact.map(pair).join("")}</li>`)
        }
        list.innerHTML = rows.join("")
        desc.hidden = false
    }

    selectVariant(btn) {

        this.variantsBox.querySelectorAll(".svc-card__variant").forEach(item => {
            item.classList.remove("is-active")
        })

        btn.classList.add("is-active")

        this.updateVariantDesc(btn)

        this.currentVariant = {
            id: btn.dataset.id,
            title: btn.dataset.title,
            price: btn.dataset.price,
            compareAtPrice: btn.dataset.compareAtPrice || ""
        }

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const hidden = this.card.querySelector(".svc-card__form [name=quantity]")

        if (qtyInput) qtyInput.value = 1
        if (hidden) hidden.value = 1

        this.syncForm()

    }

    syncForm() {

        if (!this.form) return

        this.updateTotalPrice()

        this.form.querySelector("[name=id]").value = this.currentVariant.id
        this.form.querySelector("[name=variant_title]").value = this.currentVariant.title
        this.form.querySelector("[name=price]").value = this.currentVariant.price

        const compareField = this.form.querySelector("[name=compare_at_price]")

        if (compareField) {
            compareField.value = this.currentVariant.compareAtPrice || ""
        }

    }

}

class ProductCardManager {

    constructor() {

        this.cards = new Map()

        document.querySelectorAll(".svc-card").forEach(card => {

            try {
                const instance = new ProductCard(card)

                this.cards.set(card, instance)
            } catch (error) {
                console.error('[SVC] card init failed:', card.dataset.productId || card.dataset.type || 'unknown', error)
            }

        })

        document.addEventListener("click", this.handleClick.bind(this))

    }

    initCards(root) {
        const cards = root.querySelectorAll(".svc-card")

        cards.forEach(card => {
            if (this.cards.has(card)) return

            try {
                const instance = new ProductCard(card)
                this.cards.set(card, instance)
            } catch (error) {
                console.error('[SVC] card init failed:', card.dataset.productId || card.dataset.type || 'unknown', error)
            }
        })
    }


    getCard(el) {

        const cardEl = el.closest(".svc-card")

        if (!cardEl) return null

        return this.cards.get(cardEl)

    }

    handleClick(e) {

        const card = this.getCard(e.target)

        if (!card) return

        if (e.target.closest(".svc-card__choose")) {

            if (card.type === "instant") {
                card.setScreen(3)
            }

            else {
                card.setScreen(2)
            }

        }

        if (e.target.closest(".svc-card__subproduct-select")) {
            card.setScreen(3)
        }

        if (e.target.closest(".svc-card__back")) {

            if (card.type === "instant") {
                card.setScreen(1)
                return
            }

            if (card.card.classList.contains("is-screen-3")) {
                card.setScreen(2)
            } else {
                card.setScreen(1)
            }

        }


        const plusBtn = e.target.closest(".svg-card__quantity-btn--plus")
        const minusBtn = e.target.closest(".svg-card__quantity-btn--minus")

        if (plusBtn || minusBtn) {

            const cardEl = e.target.closest(".svc-card")
            const cardInstance = this.cards.get(cardEl)

            const input = cardEl.querySelector(".svg-card__quantity-input")
            const hidden = cardEl.querySelector(".svc-card__form [name=quantity]")

            let value = parseInt(input.value) || 1

            if (plusBtn) value++
            if (minusBtn) value--

            if (value < 1) value = 1

            input.value = value

            if (hidden) hidden.value = value

            cardInstance.updateTotalPrice()

            return
        }

        const subproduct = e.target.closest(".svc-card__subproduct")

        if (subproduct && card.type !== "instant") {
            card.selectSubproduct(subproduct)
            return
        }

        // 09.09.2026: мітка поверхні для вимірювання - купівля з ОКРЕМОЇ картки товару
        // чи зі списку типів усередині батьківської картки (card_type = default)
        const buyBtn = e.target.closest(".svc-card__buy")

        if (buyBtn) {

        }

        const variant = card.type === "instant"
            ? e.target.closest(".svc-card__subproduct")
            : e.target.closest(".svc-card__variant")

        if (variant) {

            if (card.type === "instant") {

                const container = card.subproductsBox

                container?.querySelectorAll(".svc-card__subproduct-form").forEach(f => {
                    f.classList.remove("is-active")
                })

                const form = variant.closest("form")
                if (form) form.classList.add("is-active")

                return
            }
            card.selectVariant(variant)

        }

    }

}

window.productCardManager = new ProductCardManager()

document.addEventListener("input", e => {

    const input = e.target.closest(".svg-card__quantity-input")
    if (!input) return

    const card = input.closest(".svc-card")
    const hidden = card.querySelector(".svc-card__form [name=quantity]")

    let value = parseInt(input.value) || 1

    if (value < 1) value = 1

    input.value = value

    if (hidden) hidden.value = value

    const instance = window.productCardManager?.cards.get(card)
    instance?.updateTotalPrice()

})

// Навігація з картки (лого/заголовок): миттєвий фідбек стандартним
// 12-бар лоадером на тілі картки + prefetch PDP при наведенні/тачі.
document.addEventListener("click", e => {
    const nav = e.target.closest("[data-card-nav]")
    if (!nav) return
    const card = nav.closest(".svc-card")
    if (!card || card.querySelector(".svc-card__nav-loader")) return
    const ov = document.createElement("div")
    ov.className = "svc-card__nav-loader"
    ov.innerHTML = '<span class="ps-ring"></span>'
    card.appendChild(ov)
    // страховка: якщо навігація не відбулась — не тримаємо картку під лоадером
    setTimeout(() => ov.remove(), 8000)
})

// Повернення назад відновлює сторінку з bfcache разом з оверлеєм — прибираємо
window.addEventListener("pageshow", () => {
    document.querySelectorAll(".svc-card__nav-loader").forEach(el => el.remove())
})

const psPrefetched = new Set()
function psPrefetchCardLink(e) {
    const nav = e.target.closest ? e.target.closest("[data-card-nav]") : null
    if (!nav || !nav.href || psPrefetched.has(nav.href)) return
    psPrefetched.add(nav.href)
    const l = document.createElement("link")
    l.rel = "prefetch"
    l.href = nav.href
    document.head.appendChild(l)
}
document.addEventListener("touchstart", psPrefetchCardLink, { passive: true })
document.addEventListener("mouseover", psPrefetchCardLink)


// Поверхня картки (Q2): звідки саме взаємодія — для сегментації ефективності редизайну
// (колекція / best-sellers / related / search / cart-rec / slider). Визначаємо з DOM-предка.
function psCardSurface(el) {
    if (!el || !el.closest) return "other"
    if (el.closest("[data-cart-recommendations], .recs-complementary")) return "cart-rec"
    if (el.closest(".recs-viewed")) return "recently-viewed"
    if (el.closest("[data-related-products]")) return "related"
    if (el.closest("#best-sellers")) return "best-sellers"
    if (el.closest(".search-grid")) return "search"
    if (el.closest(".swiper-recs")) return "recs"
    if (el.closest(".tag-products-grid, .product-grid")) return "collection"
    if (el.closest(".swiper-product")) return "slider"
    return "other"
}

// Аналітика місця додавання в кошик: PDP чи картка, з виміром поверхні (Q2).
document.addEventListener("click", e => {
    const pdpBtn = e.target.closest(".ppc__buy, .ppc__mobile-dock-buy")
    const cardBtn = pdpBtn ? null : e.target.closest(".svc-card__buy")
    if (!pdpBtn && !cardBtn) return
    const name = pdpBtn ? "add_to_cart_pdp" : "add_to_cart_card"
    const surface = pdpBtn ? "pdp" : psCardSurface(cardBtn)
    // 09.09.2026: шлях покупки - «standalone» (власна картка товару) чи «picker» (список типів
    // усередині батьківської картки). Потрібно, щоб порівняти два шляхи для того самого товару.
    const cardEl = cardBtn ? cardBtn.closest(".svc-card") : null
    const path = cardEl ? (cardEl.dataset.cardType === "default" ? "picker" : "standalone") : ""
    const params = { card_surface: surface }
    if (path) params.buy_path = path
    if (typeof window.psTrack === "function") window.psTrack(name, params, { card_surface: surface })
})

// Клік по default-картці, що НАВІГУЄ на PDP (image/title-лінки на головній/слайдерах, де
// пікер не відкривається in-place) — раніше на цих поверхнях не було жодного сигналу інтенту.
document.addEventListener("click", e => {
    const nav = e.target.closest("[data-card-nav]")
    if (!nav || !nav.closest(".svc-card")) return
    const surface = psCardSurface(nav)
    if (typeof window.psTrack === "function") window.psTrack("card_cta_click", { card_surface: surface }, { card_surface: surface })
})

// Мікро-воронка пікера в картці: наскільки юзерам ок дропдаун і вкладеність.
// card_picker_open -> card_option_dropdown_open -> card_variant_select ->
// add_to_cart_card; card_picker_close без додавання = сигнал фрустрації. Усе з виміром поверхні.
document.addEventListener("click", e => {
    const map = [
        [".svc-card__choose", "card_picker_open"],
        [".svc-card__subproduct-select", "card_option_dropdown_open"],
        [".svc-card__subproduct", "card_option_select"],
        [".svc-card__variant", "card_variant_select"],
        [".svg-card__quantity-btn", "card_qty_stepper"],
        [".svc-card__back", "card_picker_close"]
    ]
    for (const [sel, name] of map) {
        const hit = e.target.closest(sel)
        if (hit) {
            const surface = psCardSurface(hit)
            if (typeof window.psTrack === "function") window.psTrack(name, { card_surface: surface }, { card_surface: surface })
            return
        }
    }
})
